<template>
    <div id="batch-paintlist-page">
        <div class="batch-actions">
            <ui5-label for="productnr">
                {{ trans('pages.batch_paintlist_page.enter_paintlist') }}
            </ui5-label>
            <div>
                <ui5-input
                    id="product-nr"
                    type="Text"
                    name="product-nr"
                    @keyup.enter="addPaintlistToBatch"
                    :value="paintlistNr"
                    @input="paintlistNr = $event.target.value"
                />
                <ui5-button
                    @click="addPaintlistToBatch"
                    :disabled="adding || processing"
                >
                    <div>
                        <spinner v-if="adding" />
                        <div>{{ trans('pages.batch_paintlist_page.add') }}</div>
                    </div>
                </ui5-button>
                <ui5-button
                    @click="processBatchPaintlist"
                    :disabled="adding || processing"
                >
                    <div>
                        <spinner v-if="processing" />
                        <div>
                            {{
                                trans('pages.batch_paintlist_page.process_list')
                            }}
                        </div>
                    </div>
                </ui5-button>
            </div>
        </div>
        <div id="batchpaintlistelements">
            <div
                v-for="(item, index) in list"
                class="batchelement"
                :key="item"
            >
                <div
                    class="batchelementaction"
                    @click="$delete(list, index)"
                >
                    X
                </div>
                <div class="batchelementtext">{{ item }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import optimizedPaintListApi from '../api/optimizedPaintList';
import Spinner from '../components/loader/Spinner';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner },
    mixins: [localization],
    data() {
        return {
            adding: false,
            processing: false,
            paintlistNr: '',
            list: [],
        };
    },
    methods: {
        addPaintlistToBatch() {
            this.adding = true;
            optimizedPaintListApi
                .fetchForBatch('getPaintlistForBatch', this.paintlistNr)
                .then((response) => {
                    const paintlistId = response.data.data.paintlistId;
                    if (this.list.includes(paintlistId)) {
                        return showInfoMessage(
                            this.trans(
                                'pages.batch_paintlist_page.paintlist_already_exists'
                            )
                        );
                    }
                    this.list.push(paintlistId);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.batch_paintlist_page.invalid_or_scanned_paintlist'
                        )
                    );
                })
                .finally(() => {
                    this.adding = false;
                });
            this.paintlistNr = '';
        },
        processBatchPaintlist() {
            this.processing = true;

            const successes = [];
            const promises = [...this.list].map((paintlistId) => {
                return optimizedPaintListApi
                    .updateStatus(paintlistId)
                    .then(() => {
                        successes.push(paintlistId);
                    });
            });

            Promise.allSettled(promises).then(() => {
                this.processing = false;
                this.list = this.list.filter((x) => !successes.includes(x));
                if (this.list.length == 0) {
                    showInfoMessage(
                        this.trans(
                            'pages.batch_paintlist_page.all_paintlists_processed'
                        )
                    );
                    this.$router.push('/menu');
                } else {
                    showErrorMessage(
                        this.trans(
                            'pages.batch_paintlist_page.some_paintlists_not_processed'
                        )
                    );
                }
            });
        },
    },
};
</script>
